<app-loading-spinner [active]="loading"></app-loading-spinner>

<div class="row no-gutters" [formGroup]="form">
    <div class="col-12 offset-lg-1 col-lg-10">

        <!-- Card do perfil - aparece antes dos campos quando existe perfil -->
        <div class="row"
            *ngIf="data && (data.score || not_declared || data.profile || data.is_exempt)">
            <div class="col-12 d-flex align-items-center justify-content-end">
                <div class="profile-card">
                    <div
                        class="profile-card__decoration profile-card__decoration--top">
                    </div>
                    <div
                        class="profile-card__decoration profile-card__decoration--bottom">
                    </div>

                    <div class="profile-card__content">
                        <div class="profile-card__main">
                            <p *ngIf="!data.is_exempt" class="profile-card__label">
                                Seu perfil é
                            </p>
                            <p class="profile-card__title">
                                {{ data.is_exempt ? 'DISPENSADO POR NORMA CONF.
                                ICVM 30, ART. 10 itens II, III Ou IV' :
                                getRiskLabel() }}
                            </p>
                            <p *ngIf="getEnquadramentoLabel() && !data.is_exempt"
                                class="profile-card__subtitle">
                                {{ getEnquadramentoLabel() }}
                            </p>
                        </div>

                        <div class="profile-card__meta" *ngIf="!data.is_exempt">
                            <div>
                                <span class="profile-card__meta-label">
                                    Data de início
                                </span>
                                <span class="profile-card__meta-value">
                                    {{data.start_date | date: 'dd/MM/yyyy' ??
                                    '-'}}
                                </span>
                            </div>
                            <!-- <div>
                                <span
                                    style="font-size: 10px; color: color-mix(in srgb, var(--white) 70%, transparent); display: block; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.6px; font-weight: 600;">
                                    Data de validade
                                </span>
                                <span
                                    style="font-size: 16px; color: var(--white); font-weight: 700; letter-spacing: 0.2px;">
                                    {{getExpireDate() | date: 'dd/MM/yyyy' ??
                                    '-'}}
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Questionário - escondido quando perfil é "Não declarado" e showQuestionnaire é false -->
        <ng-container *ngIf="showQuestionnaire">
            <ng-container *ngFor="let option of options; let i = index">
                <div class="row">
                    <div class="col-12 col-lg-10">
                        <span
                            *ngIf="form.controls[option.formControl].value === null"
                            class="is-required">*</span>
                        <span
                            class="basic-content-subtitle">{{option.title}}</span>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row"
                    *ngFor="let suboption of option.suboptions;let i = index">

                    <div class="offset-1 col-9">
                        <app-radio
                            [isChecked]="form.controls[option.formControl].value === suboption.value"
                            [formControlName]="option.formControl"
                            [value]="suboption.value">
                            <div class="flex-1 d-flex flex-column">
                                <span
                                    class="basic-content-description"><strong>{{i+1}})</strong>
                                    {{suboption.label}}</span>
                            </div>
                        </app-radio>

                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                </div>

                <app-spacer [bottom]="24"></app-spacer>
            </ng-container>

            <app-spacer [bottom]="48"></app-spacer>
        </ng-container>

        <!-- Botões para quando o questionário está escondido -->
        <div class="row"
            *ngIf="!showQuestionnaire && data && (data.score || not_declared || data.profile || data.is_exempt)">
            <div class="col-12 d-flex align-items-center justify-content-end">
                <app-button (onClick)="showQuestionnaireForm()"
                    [outline]="true">
                    {{ not_declared ? 'Declarar perfil de investidor' :
                    'Responder novamente' }}
                </app-button>
            </div>
        </div>

        <!-- Botões de ação - só aparecem quando o questionário está visível -->
        <div class="row" *ngIf="showQuestionnaire">
            <div
                class="col-12 d-flex align-items-center justify-content-between">
                <app-button (onClick)="showQuestionnaire = false"
                    [outline]="true" [disabled]="sending || refusing">
                    Cancelar
                </app-button>

                <div class="d-flex align-items-center">
                    <app-button (onClick)="toggleRefuseModal(true)"
                        [outline]="true" [disabled]="sending || refusing"
                        [loading]="refusing" type="submit">
                        {{ (data && (data.score || data.profile) &&
                        !not_declared) ? 'Remover perfil' : 'Pular questionário'
                        }}
                    </app-button>

                    <app-spacer [right]="16"></app-spacer>

                    <app-button (onClick)="applyNormDispense()" [outline]="true"
                        [disabled]="sending || refusing" [loading]="refusing"
                        type="submit">
                        DISPENSA POR NORMA CONF. ICVM 30, ART. 10 itens II, III ou IV
                    </app-button>

                    <app-spacer [right]="16"></app-spacer>

                    <app-button (onClick)="checkProfile()"
                        [disabled]="sending || !form.valid" [loading]="sending"
                        type="submit">
                        Salvar dados
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-warning-modal [active]="redirectWarning" [hideCloseButton]="true">
    <h3>Atenção</h3>
    <app-spacer [bottom]="24"></app-spacer>

    <p>Para prosseguir, é necessário completar a etapa
        <strong>Dados complementares: Geral.</strong>
    </p>

    <app-spacer [bottom]="56"></app-spacer>

    <app-button class="add-button" (onClick)="redirectUser()" [center]="true">
        ok
    </app-button>
</app-warning-modal>

<!-- Modal de confirmação para remover/pular questionário -->
<app-carbon-warning-modal [active]="refuseModal && showConfirmRefuse"
    [disableClose]="true" [loading]="refusing" title="Confirme sua decisão?"
    [message]="getRefuseConfirmMessage()" confirmText="Sim" cancelText="Não"
    [confirmAction]="handleConfirmRefuse" [cancelAction]="handleCancelRefuse">
</app-carbon-warning-modal>

<!-- Modal inicial perguntando se deseja retornar e responder -->
<app-carbon-warning-modal [active]="refuseModal && !showConfirmRefuse"
    [disableClose]="true" [loading]="false" title="Atenção"
    message="<p>É necessário responder as questões de avaliação de perfil de investidor.</p><p>Deseja retornar e responder as questões?</p>"
    confirmText="Sim" cancelText="Não" [confirmAction]="handleReturnToQuestions"
    [cancelAction]="handleShowConfirmRefuse">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showDisqualificationModal"
    [disableClose]="true" [loading]="sending"
    title="Atenção - Desenquadramento de Perfil"
    [message]="'<p><strong>Seu perfil de investidor não se enquadra nos critérios de público alvo do fundo de interesse.</strong></p><p>Ao clicar em &quot;Sim, estou ciente do desenquadramento&quot;, você estará <strong>aceitando explicitamente o desenquadramento</strong> e assumindo a responsabilidade por esta decisão.</p><p>Deseja continuar mesmo assim?</p>'"
    confirmText="Sim, estou ciente do desenquadramento"
    cancelText="Não, quero refazer"
    [confirmAction]="handleAcceptDisqualification"
    [cancelAction]="handleRefuseDisqualification">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showDispenseModal" [disableClose]="true"
    [loading]="refusing" title="Atenção - Dispensa por Norma"
    message="<p><strong>Você será dispensado de responder o questionário de perfil de investidor conforme ICVM 30, Art. 10, itens II, III ou IV.</strong></p><p>Será necessário comprovar a dispensa na etapa de anexos.</p><p>Deseja prosseguir mesmo assim?</p>"
    confirmText="Sim, desejo prosseguir" cancelText="Não, quero responder"
    [confirmAction]="handleConfirmDispense"
    [cancelAction]="handleCancelDispense">
</app-carbon-warning-modal>